import _ from "lodash";
import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";
import cls from "classnames";
import {
  ROLLEN,
  ROLLEN_PR,
  ROLLEN_SACHB,
} from "App/constants";
import store from "CommonState/store";
import {
  Awesome,
  Tooltip,
} from "CommonComponents/bricks";
import {
  Alert,
} from "react-bootstrap";
import {
  trimStart,
} from "CommonCore/util";
import {
  derived,
} from "CommonState/action-helpers";

const navbarMenu = [
  {
    label: "Startseite",
    icon: "home",
    to: "/",
  },
  // ---------------------- Antragsteller ----------------------
  {
    label: "Persönliche Angaben",
    icon: "address-card",
    to: `/person/stamm`,
    roles: [ROLLEN.ROLLE_ANTRAGSTELLER],
  },
  {
    label: "Vorgesehene Maßnahmen",
    icon: "briefcase",
    to: "/massnahmevorgesehen",
    roles: [ROLLEN.ROLLE_ANTRAGSTELLER],
  },
  {
    label: "Meine Anträge",
    icon: "file-alt",
    to: "/antrag",
    roles: [ROLLEN.ROLLE_ANTRAGSTELLER],
  },
  {
    label: "Meine Verträge",
    icon: "file",
    to: "/vertrag",
    roles: [ROLLEN.ROLLE_ANTRAGSTELLER],
  },

  // ---------------------- Sachbearbeiter -------------------------
  {
    label: "Anträge",
    icon: "file-alt",
    to: "/antrag",
    roles: [...ROLLEN_SACHB, ROLLEN.ROLLE_DEZ1_3, ROLLEN.ROLLE_GLEICHSTELLUNG, ...ROLLEN_PR, ROLLEN.ROLLE_ADMIN, ROLLEN.ROLLE_DEKANAT, ROLLEN.ROLLE_PERSONALLEITUNG, ROLLEN.ROLLE_SACHGEBIETSLEITUNG],
  },
  {
    label: "Verträge",
    icon: "file",
    to: "/vertrag",
    roles: [...ROLLEN_SACHB, ROLLEN.ROLLE_DEZ1_3, ROLLEN.ROLLE_GLEICHSTELLUNG, ROLLEN.ROLLE_ADMIN, ROLLEN.ROLLE_DEKANAT, ROLLEN.ROLLE_PERSONALLEITUNG, ROLLEN.ROLLE_SACHGEBIETSLEITUNG],
  },

  {
    label: "Maßnahmenplanung",
    icon: "briefcase",
    to: "/massnahme",
    roles: [ROLLEN.ROLLE_ADMIN, ...ROLLEN_SACHB, ROLLEN.ROLLE_DEKANAT, ROLLEN.ROLLE_PROFESSOR, ROLLEN.ROLLE_PERSONALLEITUNG, ROLLEN.ROLLE_SACHGEBIETSLEITUNG],
  },
  {
    label: "Auswertungen",
    icon: "list",
    roles: [ROLLEN.ROLLE_SACHBEARBEITER_LEHRAUFTRAG, ROLLEN.ROLLE_ADMIN], // Aktuell gibt es nur Lehrauftrag-Auswertungen, daher die Einschränkung vorne
    submenu: [
      {
        label: "Lehraufträge Neu",
        to: "/auswertung/lehraufträge",
        roles: [ROLLEN.ROLLE_SACHBEARBEITER_LEHRAUFTRAG],
      },
      {
        label: "Lehraufträge je FK",
        to: "/auswertung/lehraufträge_fk",
        roles: [ROLLEN.ROLLE_SACHBEARBEITER_LEHRAUFTRAG],
      },

    ],
  },
  {
    label: "Änderungen",
    icon: "asterisk",
    to: "/aenderungsmitteilung",
    roles: [...ROLLEN_SACHB, ROLLEN.ROLLE_ADMIN],
  },
  {
    label: "Benutzerverwaltung",
    icon: "users",
    to: "/nutzer",
    roles: [ROLLEN.ROLLE_ADMIN],
  },
  {
    label: "Hilfe",
    icon: "question-circle",
    to: "/hilfe",
    roles: ["*"],
  },

];

function fillParents(itemArray, parent) {
  for (const item of itemArray) {
    item.parent = parent;
    if (item.submenu) {
      fillParents(item.submenu, item);
    }
    if (item.defaultSubitem) {
      const subitem = item.submenu.find(i => i.label == item.defaultSubitem);
      if (subitem) {
        item.subto = subitem.to;
      }
    } else {
      if (!item.to && item.submenu && item.submenu[0]) {
        item.subto = item.submenu[0].to;
      }
    }
  }
}
fillParents(navbarMenu);

function hasFeature() {
  // Dummy
  return true;
}

function filterMenuFromConfig(menu, uiconfig, parent, user) {
  if (!uiconfig) {
    return [];
  }
  return _.filter(menu, item => (!item.requires || uiconfig[item.requires])
    && (!item.featuredependencies || hasFeature(item.featuredependencies))
    && (!item.roles || item.roles[0] == "*" || item.roles.indexOf(user.ro_id) >= 0))
    .map(item => {
      const itemCopy = _.clone(item);
      itemCopy.parent = parent;
      if (item.submenu) {
        itemCopy.submenu = filterMenuFromConfig(itemCopy.submenu, uiconfig, itemCopy, user);
        // Prüfen ob Default-Untermenü nach Filterung noch erreichbar ist
        if (itemCopy.subto && !_.isEmpty(itemCopy.submenu) && !itemCopy.submenu.find(x => x.to == itemCopy.subto)) {
          // Nein, via Berechtigungen entfernt
          itemCopy.subto = itemCopy.submenu[0].to;
        }
      }
      if (item.submenu && _.isEmpty(itemCopy.submenu)) {
        return;
      }
      return itemCopy;
    }).filter(_.identity);
}

function findActiveItems(menu, location) {
  function isActive(item) {
    const decodedPathname = decodeURIComponent(location.pathname);
    const trimmedPathname = trimStart(decodedPathname, "/");
    const trimmedItemTo = item.to && trimStart(item.to, "/");

    return item.to && trimmedPathname.startsWith(trimmedItemTo);
  }

  return _.filter(menu, isActive).concat(
    _.flatMap(menu, item => findActiveItems(item.submenu, location)),
  );
}

function menuFromConfig(baseMenu, uiconfig, location, user) {
  const menu = filterMenuFromConfig(baseMenu, uiconfig, null, user);
  const activeItems = findActiveItems(menu, location);
  let activeItem = _.maxBy(activeItems, item => item.to.length);
  if (activeItem) {
    activeItem.active = true;
    activeItem = activeItem.parent;
  }
  while (activeItem) {
    activeItem.childActive = true;
    activeItem = activeItem.parent;
  }
  return menu;
}

const menuFromConfigSelector = derived(
  "menu",
  state => state.uiconfig,
  (_x, props) => props.location,
  state => state.user,
  (uiconfig, location, user) => menuFromConfig(navbarMenu, uiconfig, location, user),
);


@store("dashboardMenuCollapsed", "uiconfig", "user", menuFromConfigSelector)
export default class DashboardMenu extends Component {
  get collapsed() {
    return this.props.dashboardMenuCollapsed;
  }

  render() {
    const { user, menu } = this.props;
    const info = user && user.serverinfo;

    // let collapsed = this.props.dashboardMenuCollapsed;
    return (<nav className={cls({ "navbar-default": true, "navbar-static-side": true, "menu-collapsed": this.collapsed, "card-2": true })} role='navigation'>
      <div className='nav-header'>
        <div className='logo' alt=' '>
          <div style={{ textTransform: "none", whiteSpace: "nowrap" }}>e-Portal</div>
        </div>
      </div>

      {info && !info.production && <Alert style={{ margin: "1px" }} variant='warning'>{user.serverinfo.servername}</Alert>}

      <div className='metismenu'>
        {this.renderMenu(menu, 0)}
      </div>

    </nav>);
  }

  /*
   *<div className='metismenu'>
   *<ul className='metismenu-container'>
   *  {_.map(menu, (item, index) => {
   *    if (!item.roles || item.roles[0] == '*' || item.roles.indexOf(user.ro_id) >= 0) {
   *      let content =
   *        <Link
   *          to={item.to} className={cls({
   *            'metismenu-link': true,
   *            active: item.to === activeItem.to,
   *          })}>
   *          <span>
   *            <Awesome name={item.icon} className='metismenu-icon' />
   *            <span>{item.label}</span>
   *          </span>
   *        </Link>
   *      return <li key={index} className='metismenu-item'>
   *        {!collapsed
   *          ? content
   *          : <Tooltip overlay={item.label} placement='right'>{content}</Tooltip>
   *        }
   *      </li>
   *    }
   *  })}
   *</ul>
   *</div>
   *
   */

  renderMenu(menu, level) {
    return (
      <ul className={cls({
        "metismenu-container": true,
        [`metismenu-level-${ level }`]: true,
      })}>
        {_.flatMap(menu, (item, index) => {
          const content =
            <Link
              to={item.to || item.subto} className={cls({
                "metismenu-link": true,
                active: item.active,
                "child-active": item.childActive,
              })}>
              <span>
                {item.icon ? <Awesome name={item.icon} className='metismenu-icon' /> : <span style={{ width: "2em" }} />}
                <span>{level > 0 || !this.collapsed ? item.label : ""}</span>
              </span>
              {item.submenu && !this.collapsed && <Awesome className='chevron' name={item.childActive ? "chevron-down" : "chevron-right"} />}
            </Link>;

          return (
            <li key={index} className='metismenu-item'>
              {!this.collapsed || item.submenu || level > 0
                ? content
                : <Tooltip overlay={item.label} placement='right'>{content}</Tooltip>
              }
              {(item.active || item.childActive || this.collapsed) && item.submenu && this.renderMenu(item.submenu, level + 1)}
            </li>
          );
        })}
      </ul>
    );
  }
}
